import axios from 'axios'
import util from '../util';

const isTestEnv = location.pathname.match('timber-');
const isLocalEnv = location.pathname.match('mkdesigner');
const isStageEnv = location.pathname.match('xstage');

const BRAND_PATH = (isLocalEnv ? 'https://test.mhmfun.com/account-test' 
                        : isTestEnv ? 'https://test.mhmfun.com/account-test'
                            : isStageEnv ? 'https://www.musthavemenus.com/account-stage'
                                : '/account') 
                    + '/api/v1/brands';

const getBrandPerLocation = (locationId) => axios.get(`${BRAND_PATH}/location`, { params: { locationId }, headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') }});

const uploadBrandLogo = (brandId, formData) => axios.post(`${BRAND_PATH}/${brandId}/logo/upload`, formData, { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') }});

export default {
    getBrandPerLocation,
    uploadBrandLogo,
}
